import axios from '@/lib/axios';
import { MonthlyExternalExpense, MonthlySalesTarget, UserInvitation, Workspace } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 2440. Node管理外費用登録（更新）
 * [POST] /workspaces/:identifier/monthly_external_expenses
 */
type Props = {
  identifier: string;
  year_month: number;
  amount: number;
};
const createExternalExpense = (props: Props): Promise<MonthlyExternalExpense> => {
  return axios.post(`/api/workspaces/${props.identifier}/monthly_external_expenses`, props);
};

export const useCreateExternalExpense = () => {
  return useMutation({
    mutationFn: createExternalExpense,
  });
};
